import { useState, useEffect } from "react"
import { useNavigate, useParams, Link } from "react-router-dom"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"
import MDInput from "components/MDInput"
import { Checkbox, FormControlLabel, Tab, Tabs } from "@mui/material"
import { showToast } from "utils/swalToast"
import { fetchPost, fetchEmpresasById, updateEmpresas, fetchAllServicios } from "./service"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import SiteImagesSection from "monitor/Configurator/SiteImagesSection"
import PropTypes from "prop-types"

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <MDBox sx={{ p: 3 }}>{children}</MDBox>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function Add() {
  const [empresasToEdit, setEmpresasToEdit] = useState(null)
  const navigate = useNavigate()
  const { id } = useParams()
  const [tabValue, setTabValue] = useState(0)

  const [formData, setFormData] = useState({
    descripcion: "",
    telefono: "",
    direccion: "",
    activo: "",
    asistenciaHabilitada: false,
  })

  useEffect(() => {
    if (id) {
      fetchEmpresasById(id).then((em) => {
        setEmpresasToEdit(em)
        setFormData({
          descripcion: em.descripcion || "",
          direccion: em.direccion || "",
          telefono: em.telefono || "",
          activo: em.activo || "",
          asistenciaHabilitada: Boolean(em.asistenciaHabilitada),
        })
      })
    }
  }, [id])

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault()

    const data = {
      descripcion: formData.descripcion,
      direccion: formData.direccion,
      telefono: formData.telefono,
      logo: formData.logo,
      activo: Boolean(formData.activo),
      asistenciaHabilitada: Boolean(formData.asistenciaHabilitada),
    }

    try {
      if (empresasToEdit) {
        await updateEmpresas(id, data)
        showToast({ title: "Empresa actualizada exitosamente", icon: "success" })
      } else {
        await fetchPost(data)
        showToast({ title: "Empresa agregada exitosamente", icon: "success" })
      }
      navigate("/empresas")
    } catch (error) {
      console.error("Error en la operación:", error)
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant="h5">
                  {empresasToEdit ? "Editar empresa" : "Agregar empresa"}
                </MDTypography>
              </MDBox>
              <MDBox sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleChangeTab}>
                  <Tab label="DATOS" {...a11yProps(0)} />
                  <Tab label="IMAGENES" {...a11yProps(1)} />
                </Tabs>
              </MDBox>
              <CustomTabPanel value={tabValue} index={0}>
                <MDBox pt={2} px={2} component="form" role="form" onSubmit={handleSubmit}>
                  <MDBox mb={2}>
                    <MDInput
                      type="text"
                      name="descripcion"
                      label="Razon Social"
                      fullWidth
                      value={formData.descripcion}
                      onChange={handleChange}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      type="text"
                      name="direccion"
                      label="Dirección"
                      fullWidth
                      value={formData.direccion}
                      onChange={handleChange}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      type="text"
                      name="telefono"
                      label="Teléfono"
                      fullWidth
                      value={formData.telefono}
                      onChange={handleChange}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="activo"
                          checked={Boolean(formData.activo)}
                          onChange={(e) =>
                            handleChange({ target: { name: "activo", value: e.target.checked } })
                          }
                        />
                      }
                      label="ACTIVO"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="asistenciaHabilitada"
                          checked={Boolean(formData.asistenciaHabilitada)}
                          onChange={(e) =>
                            handleChange({ target: { name: "asistenciaHabilitada", value: e.target.checked } })
                          }
                        />
                      }
                      label="HABILITAR ASISTENCIA"
                    />
                  </MDBox>
                  <MDBox mb={2} mt={2} sx={{ textAlign: "center" }}>
                    {!id && <Link to="/empresas">
                      <MDButton variant="outlined" color="info" sx={{ mb: 1, width: "100%" }}>
                        Cancelar
                      </MDButton>
                    </Link>}
                    <MDButton type="submit" variant="gradient" color="info" sx={{ width: "100%" }}>
                      {empresasToEdit ? "Actualizar Datos" : "Agregar"}
                    </MDButton>
                  </MDBox>
                </MDBox>
              </CustomTabPanel>
              <CustomTabPanel value={tabValue} index={1}>
                <SiteImagesSection showTitle={false} companyId={id} companyName={formData.descripcion} />
              </CustomTabPanel>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout >
  )
}
export default Add
